module.exports = __webpack_public_path__ + "static/img/model-bg1.e2eb7cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg1.jpg
// module id = oo62
// module chunks = 0